import { Check, X } from "lucide-react";

export const passwordChecks = (password = "") => ({
  length: password.length >= 8,
  upper: /[A-Z]/.test(password),
  lower: /[a-z]/.test(password),
  digit: /\d/.test(password),
  special: /[^A-Za-z0-9]/.test(password),
});

export const isPasswordValid = (password = "") =>
  Object.values(passwordChecks(password)).every(Boolean);

const RULES = [
  { key: "length", label: "Au moins 8 caractères" },
  { key: "upper", label: "Une lettre majuscule" },
  { key: "lower", label: "Une lettre minuscule" },
  { key: "digit", label: "Un chiffre" },
  { key: "special", label: "Un caractère spécial (!@#…)" },
];

const PasswordStrength = ({ password = "" }) => {
  if (!password) {
    return (
      <p className="text-xs text-[#64748B] mt-1">
        8 caractères min. avec majuscule, minuscule, chiffre et caractère spécial
      </p>
    );
  }

  const checks = passwordChecks(password);
  const score = Object.values(checks).filter(Boolean).length;
  const levels = [
    { w: "20%", c: "bg-red-500", t: "Très faible", tc: "text-red-400" },
    { w: "40%", c: "bg-orange-500", t: "Faible", tc: "text-orange-400" },
    { w: "60%", c: "bg-yellow-500", t: "Moyen", tc: "text-yellow-400" },
    { w: "80%", c: "bg-lime-500", t: "Bon", tc: "text-lime-400" },
    { w: "100%", c: "bg-emerald-500", t: "Fort", tc: "text-emerald-400" },
  ];
  const level = levels[Math.max(0, score - 1)];

  return (
    <div className="mt-2" data-testid="password-strength">
      <div className="flex items-center gap-2 mb-2">
        <div className="flex-1 h-1.5 bg-[#2A3A4D] rounded-full overflow-hidden">
          <div
            className={`h-full ${level.c} transition-all duration-300`}
            style={{ width: level.w }}
          />
        </div>
        <span className={`text-xs font-medium ${level.tc}`} data-testid="password-strength-label">
          {level.t}
        </span>
      </div>
      <ul className="grid grid-cols-1 gap-0.5">
        {RULES.map((rule) => (
          <li key={rule.key} className="flex items-center gap-1.5 text-xs">
            {checks[rule.key] ? (
              <Check className="w-3 h-3 text-emerald-400 flex-shrink-0" />
            ) : (
              <X className="w-3 h-3 text-[#64748B] flex-shrink-0" />
            )}
            <span className={checks[rule.key] ? "text-emerald-400" : "text-[#64748B]"}>
              {rule.label}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PasswordStrength;
